/* eslint-disable react/no-unescaped-entities */
import React from 'react'

import List, { ListItem } from '@cinch/oxd-components/list/src'
import Panel from '@cinch/oxd-components/panel/src'
import RichText from '@cinch/oxd-components/rich-text/src'

import * as styles from './information-panel.module.css'

interface InformationPanelProps {
  onClickFee: () => void
}

const InformationPanel: React.FC<InformationPanelProps> = ({ onClickFee }) => {
  return (
    <Panel title="Important information">
      <RichText>
        <List className={styles.list}>
          <ListItem>
            <span>
              Sale may be{' '}
              <button onClick={onClickFee} className={styles.button}>
                subject to a transaction fee.*
              </button>
            </span>
          </ListItem>
          <ListItem>
            We will inspect your vehicle. Our price offer may change if we think it is affected by the vehicle's
            condition or history.
          </ListItem>
          <ListItem>Your valuation is guaranteed for 24 hours.</ListItem>
        </List>
      </RichText>
    </Panel>
  )
}

export default InformationPanel
